import { FC } from "react";
import ToggleGroup from "@src/deprecatedDesignSystem/components/ToggleGroup";
import { useLibraryItemQueryParams } from "./contexts/LibraryItemQueryParamsContext";
import { useBuilderContentPermissions } from "@src/components/libraryItemDetailPages/hooks/useBuilderContentPermissions";

const LibraryItemDetailPageHeaderNav: FC = () => {
  const { hasEditPermission } = useBuilderContentPermissions();
  const { mainTabs, selectedMainTab, setMainTab } = useLibraryItemQueryParams();
  if (!hasEditPermission) return null;
  return (
    <div>
      <ToggleGroup
        defaultValue="build"
        options={mainTabs}
        value={selectedMainTab}
        onValueChange={(value) => setMainTab(value)}
      />
    </div>
  );
};

export default LibraryItemDetailPageHeaderNav;
